//THIS OBJECT MAPS RELATIVE URL WITH DEFAULT SELECTED MENU
export const curr_active_map = {
  "/dashboard": "0",
  "/assessment": "3",
  "/career-path-exploration/target-roles": "4",
  "/career-path-exploration/target-industries": "5",
  "/research-roles": "6",
  "/research-industries": "7",
  "/networking/contacts": "8",
  "/networking/email-drafts": "9",
  "/networking/tracker": "10",
  "/networking/call-prep": "11",
  "/networking/call-notes": "12",
  "/networking/reflections": "13",
  "/learning-opportunities": "14",
  "/materials/professional-summary": "15",
  "/materials/resume": "16",
  "/materials/cover-letter": "17",
  "/materials/linkedin": "18",
  "/job-search/application-tracker": "19",
  "/job-search/interview-research": "20",
  "/job-search/interview-prep": "21",
  "/job-search/reflections": "22",
  "/calendar": "23",
  "/agenda": "29",
  "/coach-meetings": "30",
  "/meeting-notes": "31",
  "/coach-feedback": "32",
  "/mission-statement": "33",
  "/life-wheel": "34",
  "/annual-goals": "35",
  "/financial-management": "36",
  "/relationship-management": "37",
  "/travel-and-adventure": "38",
  "/giving-and-contribution": "39",
  "/Spiritual": "40",
  "/health-and-wellness": "41",
  "/location-to-live": "42",
  "/peers": "43",
  "/therapist": "44",
  "/stakeholders": "45",
  "/manager": "46",
  "/mentors": "47",
  "/my-board-of-directors": "48",
  "/group-coworking": "49",
  "/group-coaching": "50",
  "/group-meditation": "51",
  "/discussion-board": "52",
  "/accountability-triads": "53",
  "/peer-coaching": "54",
  "/annual-goal-buddy": "55",
  "/reading-buddy": "56",
  "/other-videos": "57",
  "/other-books": "58",
  "/other-blogs": "59",
  "/podcasts": "61",
  "/templates": "62",
  "/whiteboard": "64",
  "/key-links": "65",
  "/settings": "66",
  "/security": "67",
  "/my-plan": "68",
  "/billing": "69",
  "/integrations": "70",
  "/share-feedback": "71",
  // "/profile/privacy-policy": "72",
  "/mindset/my-notebook": "74",
  "/mindset/meditations": "75",
  "/mindset/mindset-goals": "76",
  "/mindset/building-confidence": "77",
  "/mindset/envisioning-yourself": "78",
  "/mindset/influence-zones": "79",
  "/mindset/past-roles-reflection": "80",
  "/mindset/networking-preparation": "81",
  "/accountability/onboarding": "82",
  "/accountability/progress-tracker": "83",
  "/accountability/my-schedule": "84",
  "/accountability/suggested-schedule": "85",
  "/accountability/my-tasks": "86",
  "/accountability/group-coworking": "87",
  "/career-path-exploration/assessment": "88",
  "/career-path-exploration/target-roles-and-industries": "89",
  "/career-path-exploration/role-research": "90",
  "/career-path-exploration/industry-research": "91",
  "/career-path-exploration/compare-roles": "92",
  "/career-path-exploration/pie-chart-exercise": "93",
  "/career-path-exploration/resume-vision-exercise": "94",
  "/career-path-exploration/key-definitions": "95",
  "/career-path-exploration/identify-gaps": "96",
  "/career-path-exploration/career-trajectory": "97",
  "/upskilling/strengths-overview": "98",
  "/upskilling/skill-gap-analysis": "99",
  "/upskilling/job-posting-exercise": "100",
  "/upskilling/upskilling-tracker": "101",
  "/upskilling/compare-options": "102",
  "/upskilling/my-credentials": "103",
  "/upskilling/key-links": "104",
  "/upskilling/soft-skill-development": "105",
  "/upskilling/boundary-setting": "106",
  "/upskilling/communication": "107",
  "/upskilling/time-management": "108",
  "/upskilling/project-management": "109",
  "/upskilling/improving-focus": "110",
  "/upskilling/influence-and-visibility": "111",
  "/personal-branding/professional-summary": "112",
  "/personal-branding/resume": "113",
  "/personal-branding/linkedin-profile": "114",
  "/personal-branding/cover-letter": "115",
  "/personal-branding/video-pitch": "116",
  "/personal-branding/portfolio-or-website": "117",
  "/personal-branding/thought-leadership": "118",
  "/personal-branding/ats-keywords": "119",
  "/networking/mindset-preparation": "120",
  "/networking/places-to-network": "121",
  "/networking/contacts-brainstorm": "122",
  "/networking/outreach-drafts": "123",
  "/networking/networking-tracker": "124",
  "/events/past-events": "125",
  "/events/upcoming-events": "126",
  "/events/find-events": "127",
  "/career-advancement/onboarding-30-60-90": "128",
  "/career-advancement/onboarding-checklist": "129",
  "/career-advancement/promotions": "130",
  "/career-advancement/internal-mobility": "131",
  "/career-advancement/performance-reviews": "132",
  "/career-advancement/job-expectations": "133",
  "/career-advancement/annual-goals": "134",
  "/career-advancement/stakeholder-updates": "135",
  "/career-advancement/track-achievements": "136",
  "/entrepreneurship/roadmap": "137",
  "/entrepreneurship/customer-personas": "138",
  "/entrepreneurship/market-research": "139",
  "/entrepreneurship/define-offerings": "140",
  "/entrepreneurship/financials": "141",
  "/entrepreneurship/marketing": "142",
  "/entrepreneurship/sales": "143",
  "/entrepreneurship/product-development": "144",
  "/entrepreneurship/team-management": "145",
  "/entrepreneurship/legal": "146",
  "/entrepreneurship/operations": "147",
  "/career-path-exploration/contacts-brainstorm": "148",
  "/career-path-exploration/outreach-drafts": "149",
  "/career-path-exploration/networking-tracker": "150",
  "/career-path-exploration/reflections": "151",
  "/job-searching/progress-tracker": "152",
  "/job-searching/strategy-and-direction": "153",
  "/job-searching/my-schedule": "154",
  "/job-searching/suggested-schedule": "155",
  "/job-searching/job-search-tracker": "156",
  "/job-searching/target-job-postings": "157",
  "/job-searching/target-companies": "158",
  "/job-searching/staffing-agencies": "159",
  "/job-searching/visa-resources": "160",
  "/job-searching/set-priorities": "161",
  "/job-searching/interview-research": "162",
  "/job-searching/interview-responses": "163",
  "/job-searching/questions-to-ask": "164",
  "/job-searching/mock-interview": "165",
  "/job-searching/case-interview": "166",
  "/job-searching/technical-interview": "167",
  "/job-searching/interview-follow-ups": "168",
  "/job-searching/standing-out": "169",
  "/job-searching/offer-analysis": "170",
  "/job-searching/salary-research": "171",
  "/job-searching/reflections": "172",
  "/job-searching/key-links": "173",
  "/job-searching/helpful-tools": "174",
  "/career-path-exploration/call-prep": "175",
  "/upskilling/education-planning": "176",
};
export const curr_active_map_filter = {
  "/dashboard": "0",
  "/assessment": "3",
  "/career-path-exploration/target-roles": "4",
  "/career-path-exploration/target-industries": "5",
  "/research-roles": "6",
  "/research-industries": "7",
  "/networking/contacts": "8",
  "/networking/email-drafts": "9",
  // "/networking/tracker": "10",
  "/networking/call-prep": "11",
  "/networking/call-notes": "12",
  "/networking/reflections": "13",
  "/learning-opportunities": "14",
  "/materials/professional-summary": "15",
  "/materials/resume": "16",
  "/materials/cover-letter": "17",
  "/materials/linkedin": "18",
  // "/job-search/application-tracker": "19",
  "/job-search/interview-research": "20",
  // "/job-search/interview-prep": "21",
  "/job-search/reflections": "22",
  "/calendar": "23",
  "/agenda": "29",
  "/coach-meetings": "30",
  "/meeting-notes": "31",
  "/coach-feedback": "32",
  "/mission-statement": "33",
  "/life-wheel": "34",
  "/annual-goals": "35",
  "/financial-management": "36",
  "/relationship-management": "37",
  "/travel-and-adventure": "38",
  "/giving-and-contribution": "39",
  "/Spiritual": "40",
  "/health-and-wellness": "41",
  "/location-to-live": "42",
  "/peers": "43",
  "/therapist": "44",
  "/stakeholders": "45",
  "/manager": "46",
  "/mentors": "47",
  "/my-board-of-directors": "48",
  "/group-coworking": "49",
  "/group-coaching": "50",
  "/group-meditation": "51",
  "/discussion-board": "52",
  "/accountability-triads": "53",
  "/peer-coaching": "54",
  "/annual-goal-buddy": "55",
  "/reading-buddy": "56",
  "/other-videos": "57",
  "/other-books": "58",
  "/other-blogs": "59",
  "/podcasts": "61",
  "/templates": "62",
  "/whiteboard": "64",
  "/key-links": "65",
  "/settings": "66",
  "/security": "67",
  "/my-plan": "68",
  "/billing": "69",
  "/integrations": "70",
  "/share-feedback": "71",
  // "/profile/privacy-policy": "72",
  "/mindset/my-notebook": "74",
  "/mindset/meditations": "75",
  "/mindset/mindset-goals": "76",
  "/mindset/building-confidence": "77",
  "/mindset/envisioning-yourself": "78",
  "/mindset/influence-zones": "79",
  "/mindset/past-roles-reflection": "80",
  "/mindset/networking-preparation": "81",
  "/accountability/onboarding": "82",
  "/accountability/progress-tracker": "83",
  "/accountability/my-schedule": "84",
  "/accountability/suggested-schedule": "85",
  "/accountability/my-tasks": "86",
  "/accountability/group-coworking": "87",
  "/career-path-exploration/assessment": "88",
  "/career-path-exploration/target-roles-and-industries": "89",
  "/career-path-exploration/role-research": "90",
  "/career-path-exploration/industry-research": "91",
  "/career-path-exploration/compare-roles": "92",
  "/career-path-exploration/pie-chart-exercise": "93",
  "/career-path-exploration/resume-vision-exercise": "94",
  "/career-path-exploration/key-definitions": "95",
  "/career-path-exploration/identify-gaps": "96",
  "/career-path-exploration/career-trajectory": "97",
  "/upskilling/strengths-overview": "98",
  "/upskilling/skill-gap-analysis": "99",
  "/upskilling/job-posting-exercise": "100",
  "/upskilling/upskilling-tracker": "101",
  "/upskilling/compare-options": "102",
  "/upskilling/my-credentials": "103",
  "/upskilling/key-links": "104",
  "/upskilling/soft-skill-development": "105",
  "/upskilling/boundary-setting": "106",
  "/upskilling/communication": "107",
  "/upskilling/time-management": "108",
  "/upskilling/project-management": "109",
  "/upskilling/improving-focus": "110",
  "/upskilling/influence-and-visibility": "111",
  "/personal-branding/professional-summary": "112",
  "/personal-branding/resume": "113",
  "/personal-branding/linkedin-profile": "114",
  "/personal-branding/cover-letter": "115",
  "/personal-branding/video-pitch": "116",
  "/personal-branding/portfolio-or-website": "117",
  "/personal-branding/thought-leadership": "118",
  "/personal-branding/ats-keywords": "119",
  "/networking/mindset-preparation": "120",
  "/networking/places-to-network": "121",
  "/networking/contacts-brainstorm": "122",
  "/networking/outreach-drafts": "123",
  "/networking/networking-tracker": "124",
  "/events/past-events": "125",
  "/events/upcoming-events": "126",
  "/events/find-events": "127",
  "/career-advancement/onboarding-30-60-90": "128",
  "/career-advancement/onboarding-checklist": "129",
  "/career-advancement/promotions": "130",
  "/career-advancement/internal-mobility": "131",
  "/career-advancement/performance-reviews": "132",
  "/career-advancement/job-expectations": "133",
  "/career-advancement/annual-goals": "134",
  "/career-advancement/stakeholder-updates": "135",
  "/career-advancement/track-achievements": "136",
  "/entrepreneurship/roadmap": "137",
  "/entrepreneurship/customer-personas": "138",
  "/entrepreneurship/market-research": "139",
  "/entrepreneurship/define-offerings": "140",
  "/entrepreneurship/financials": "141",
  "/entrepreneurship/marketing": "142",
  "/entrepreneurship/sales": "143",
  "/entrepreneurship/product-development": "144",
  "/entrepreneurship/team-management": "145",
  "/entrepreneurship/legal": "146",
  "/entrepreneurship/operations": "147",
  "/career-path-exploration/contacts-brainstorm": "148",
  "/career-path-exploration/outreach-drafts": "149",
  "/career-path-exploration/networking-tracker": "150",
  "/career-path-exploration/reflections": "151",
  "/job-searching/progress-tracker": "152",
  "/job-searching/strategy-and-direction": "153",
  "/job-searching/my-schedule": "154",
  "/job-searching/suggested-schedule": "155",
  "/job-searching/job-search-tracker": "156",
  "/job-searching/target-job-postings": "157",
  "/job-searching/target-companies": "158",
  "/job-searching/staffing-agencies": "159",
  "/job-searching/visa-resources": "160",
  "/job-searching/set-priorities": "161",
  "/job-searching/interview-research": "162",
  "/job-searching/interview-responses": "163",
  "/job-searching/questions-to-ask": "164",
  "/job-searching/mock-interview": "165",
  "/job-searching/case-interview": "166",
  "/job-searching/technical-interview": "167",
  "/job-searching/interview-follow-ups": "168",
  "/job-searching/standing-out": "169",
  "/job-searching/offer-analysis": "170",
  "/job-searching/salary-research": "171",
  "/job-searching/reflections": "172",
  "/job-searching/key-links": "173",
  "/job-searching/helpful-tools": "174",
  "/career-path-exploration/call-prep": "175",
  "/upskilling/education-planning": "176",
};

export const stepKeyToPath = {
  "AG": "/agenda",
  "CM": "/coach-meetings",
  "ME": "/meeting-notes",
  "CF": "/coach-feedback",
  "MS": "/mission-statement",
  "LS": "/life-wheel",
  "AL": "/annual-goals",
  "FM": "/financial-management",
  "RM": "/relationship-management",
  "TN": "/travel-and-adventure",
  "GT": "/giving-and-contribution",
  "SR": "/Spiritual",
  "HW": "/health-and-wellness",
  "LT": "/location-to-live",
  "PE": "/peers",
  "TH": "/therapist",
  "KH": "/stakeholders",
  "MA": "/manager",
  "MO": "/mentors",
  "MB": "/my-board-of-directors",
  "GW": "/group-coworking",
  "GH": "/group-coaching",
  "GM": "/group-meditation",
  "DB": "https://join.slack.com/t/getwoken/shared_invite/zt-za3osi0k-Wbba2fYxJHUev9Dsam3Z3Q",
  "AD": "/accountability-triads",
  "PC": "/peer-coaching",
  "AB": "/annual-goal-buddy",
  "RB": "/reading-buddy",
  "MN": "/mindset/my-notebook",
  "MD": "/mindset/meditations",
  "MG": "/mindset/mindset-goals",
  "BG": "/mindset/building-confidence",
  "EY": "/mindset/envisioning-yourself",
  "IZ": "/mindset/influence-zones",
  "RL": "/mindset/past-roles-reflection",
  "NN": "/mindset/networking-preparation",
  "MCM": "/accountability/onboarding",
  "PT": "/accountability/progress-tracker",
  "AMS": "/accountability/my-schedule",
  "SS": "/accountability/suggested-schedule",
  "MT": "/accountability/my-tasks",
  "GC": "/accountability/group-coworking",
  "AS": "/career-path-exploration/assessment",
  "AE": "/career-path-exploration/target-roles-and-industries",
  "TR": "/career-path-exploration/target-roles",
  "TI": "/career-path-exploration/target-industries",
  "RR": "/career-path-exploration/role-research",
  "RI": "/career-path-exploration/industry-research",
  "CO": "/networking/contacts-brainstorm",
  "ED": "/networking/outreach-drafts",
  "NT": "/networking/networking-tracker",
  "CP": "/networking/call-prep",
  "NF": "/networking/reflections",
  "CR": "/career-path-exploration/compare-roles",
  "PCE": "/career-path-exploration/pie-chart-exercise",
  "RV": "/career-path-exploration/resume-vision-exercise",
  "KD": "/career-path-exploration/key-definitions",
  "ID": "/career-path-exploration/identify-gaps",
  "CT": "/career-path-exploration/career-trajectory",
  "undefined": "#",
  "SO": "/upskilling/strengths-overview",
  "SG": "/upskilling/skill-gap-analysis",
  "JP": "/upskilling/job-posting-exercise",
  "LO": "/upskilling/upskilling-tracker",
  "OT": "/upskilling/compare-options",
  "EP": "/upskilling/education-planning",
  "MC": "/upskilling/my-credentials",
  "KL": "/upskilling/key-links",
  "SD": "/upskilling/soft-skill-development",
  "BS": "/upskilling/boundary-setting",
  "UP": "/upskilling/communication",
  "TM": "/upskilling/time-management",
  "PM": "/upskilling/project-management",
  "IF": "/upskilling/improving-focus",
  "IV": "/upskilling/influence-and-visibility",
  "PS": "/personal-branding/professional-summary",
  "RE": "/personal-branding/resume",
  "LK": "/personal-branding/linkedin-profile",
  "CL": "/personal-branding/cover-letter",
  "VP": "/personal-branding/video-pitch",
  "PW": "/personal-branding/portfolio-or-website",
  "TL": "/personal-branding/thought-leadership",
  "AK": "/personal-branding/ats-keywords",
  "PI": "/networking/mindset-preparation",
  "PN": "/networking/places-to-network",
  "CN": "/networking/call-notes",
  "JT": "/job-searching/progress-tracker",
  "SN": "/job-searching/strategy-and-direction",
  "MSC": "/job-searching/my-schedule",
  "JA": "/job-searching/suggested-schedule",
  "AT": "/job-searching/job-search-tracker",
  "TJ": "/job-searching/target-job-postings",
  "TC": "/job-searching/target-companies",
  "SA": "/job-searching/staffing-agencies",
  "VR": "/job-searching/visa-resources",
  "SP": "/job-searching/set-priorities",
  "IR": "/job-searching/interview-research",
  "BP": "/job-searching/interview-responses",
  "QT": "/job-searching/questions-to-ask",
  "MW": "/job-searching/mock-interview",
  "CI": "/job-searching/case-interview",
  "TE": "/job-searching/technical-interview",
  "IW": "/job-searching/interview-follow-ups",
  "ST": "/job-searching/standing-out",
  "OA": "/job-searching/offer-analysis",
  "SH": "/job-searching/salary-research",
  "JR": "/job-searching/reflections",
  "SK": "/job-searching/key-links",
  "HT": "/job-searching/helpful-tools",
  "EV": "/events/past-events",
  "UE": "/events/upcoming-events",
  "FE": "/events/find-events",
  "OD": "/career-advancement/onboarding-30-60-90",
  "OC": "/career-advancement/onboarding-checklist",
  "PR": "/career-advancement/promotions",
  "IM": "/career-advancement/internal-mobility",
  "MV": "/career-advancement/performance-reviews",
  "JE": "/career-advancement/job-expectations",
  "CG": "/career-advancement/annual-goals",
  "SU": "/career-advancement/stakeholder-updates",
  "TA": "/career-advancement/track-achievements",
  "EM": "/entrepreneurship/roadmap",
  "CS": "/entrepreneurship/customer-personas",
  "MR": "/entrepreneurship/market-research",
  "DO": "/entrepreneurship/define-offerings",
  "FN": "/entrepreneurship/financials",
  "MK": "/entrepreneurship/marketing",
  "SL": "/entrepreneurship/sales",
  "PD": "/entrepreneurship/product-development",
  "ET": "/entrepreneurship/team-management",
  "EL": "/entrepreneurship/legal",
  "OP": "/entrepreneurship/operations",
  "WVM": "https://www.youtube.com/channel/UCzENh4CtxdGdnsABkLHeAAg",
  "OVD": "/other-videos",
  "WB": "https://drive.google.com/file/d/1r0_pYv6MpTNXKBxlhK0aU9TjadZzMyOO/view",
  "OTB": "/other-books",
  "WKB": "https://www.iamwoken.com/resources",
  "OBL": "/other-blogs",
  "WW": "https://www.iamwoken.com/resources",
  "PDC": "/podcasts",
  "TMP": "/templates",
  "FAQ": "https://docs.google.com/document/d/12C7ZbxUvSIIRQuxkPt304th27gfPdHgxvDMiiZ8LCQU/edit?usp=sharing",
  "WHB": "/whiteboard",
  "KLJ": "/key-links",
  "SE": "/settings",
  "SC": "/security",
  "MP": "/my-plan",
  "BL": "/billing",
  "IN": "/integrations",
  "SF": "#",
  "PP": "/profile/privacy-policy",
  "LG": "#",
  "DAS": "/dashboard",
}

export const pathToStepKey = {
  "/agenda": "AG",
  "/coach-meetings": "CM",
  "/meeting-notes": "ME",
  "/coach-feedback": "CF",
  "/mission-statement": "MS",
  "/life-wheel": "LS",
  "/annual-goals": "AL",
  "/financial-management": "FM",
  "/relationship-management": "RM",
  "/travel-and-adventure": "TN",
  "/giving-and-contribution": "GT",
  "/Spiritual": "SR",
  "/health-and-wellness": "HW",
  "/location-to-live": "LT",
  "/peers": "PE",
  "/therapist": "TH",
  "/stakeholders": "KH",
  "/manager": "MA",
  "/mentors": "MO",
  "/my-board-of-directors": "MB",
  "/group-coworking": "GC",
  "/group-coaching": "GH",
  "/group-meditation": "GM",
  "https://join.slack.com/t/getwoken/shared_invite/zt-za3osi0k-Wbba2fYxJHUev9Dsam3Z3Q": "DB",
  "/accountability-triads": "AD",
  "/peer-coaching": "PC",
  "/annual-goal-buddy": "AB",
  "/reading-buddy": "RB",
  "/mindset/my-notebook": "MN",
  "/mindset/meditations": "MD",
  "/mindset/mindset-goals": "MG",
  "/mindset/building-confidence": "BG",
  "/mindset/envisioning-yourself": "EY",
  "/mindset/influence-zones": "IZ",
  "/mindset/past-roles-reflection": "RL",
  "/mindset/networking-preparation": "NN",
  "/accountability/onboarding": "MCM",
  "/accountability/progress-tracker": "PT",
  "/accountability/my-schedule": "AMS",
  "/accountability/suggested-schedule": "SS",
  "/accountability/my-tasks": "MT",
  "/accountability/group-coworking": "GC",
  "/career-path-exploration/assessment": "AS",
  "/career-path-exploration/target-roles-and-industries": "AE",
  "/career-path-exploration/target-roles": "TR",
  "/career-path-exploration/target-industries": "TI",
  "/career-path-exploration/role-research": "RR",
  "/career-path-exploration/industry-research": "RI",
  "/networking/contacts-brainstorm": "CO",
  "/networking/outreach-drafts": "ED",
  "/networking/networking-tracker": "NT",
  "/networking/call-prep": "CP",
  "/networking/reflections": "NF",
  "/career-path-exploration/compare-roles": "CR",
  "/career-path-exploration/pie-chart-exercise": "PCE",
  "/career-path-exploration/resume-vision-exercise": "RV",
  "/career-path-exploration/key-definitions": "KD",
  "/career-path-exploration/identify-gaps": "ID",
  "/career-path-exploration/career-trajectory": "CT",
  "/upskilling/strengths-overview": "SO",
  "/upskilling/skill-gap-analysis": "SG",
  "/upskilling/job-posting-exercise": "JP",
  "/upskilling/upskilling-tracker": "LO",
  "/upskilling/compare-options": "OT",
  "/upskilling/education-planning": "EP",
  "/upskilling/my-credentials": "MC",
  "/upskilling/key-links": "KL",
  "/upskilling/soft-skill-development": "SD",
  "/upskilling/boundary-setting": "BS",
  "/upskilling/communication": "UP",
  "/upskilling/time-management": "TM",
  "/upskilling/project-management": "PM",
  "/upskilling/improving-focus": "IF",
  "/upskilling/influence-and-visibility": "IV",
  "/personal-branding/professional-summary": "PS",
  "/personal-branding/resume": "RE",
  "/personal-branding/linkedin-profile": "LK",
  "/personal-branding/cover-letter": "CL",
  "/personal-branding/video-pitch": "VP",
  "/personal-branding/portfolio-or-website": "PW",
  "/personal-branding/thought-leadership": "TL",
  "/personal-branding/ats-keywords": "AK",
  "/networking/mindset-preparation": "NN",
  "/networking/places-to-network": "PN",
  "/networking/call-notes": "CN",
  "/job-searching/progress-tracker": "JT",
  "/job-searching/strategy-and-direction": "SN",
  "/job-searching/my-schedule": "MSC",
  "/job-searching/suggested-schedule": "JA",
  "/job-searching/job-search-tracker": "AT",
  "/job-searching/target-job-postings": "TJ",
  "/job-searching/target-companies": "TC",
  "/job-searching/staffing-agencies": "SA",
  "/job-searching/visa-resources": "VR",
  "/job-searching/set-priorities": "SP",
  "/job-searching/interview-research": "IR",
  "/job-searching/interview-responses": "BP",
  "/job-searching/questions-to-ask": "QT",
  "/job-searching/mock-interview": "MW",
  "/job-searching/case-interview": "CI",
  "/job-searching/technical-interview": "TE",
  "/job-searching/interview-follow-ups": "IW",
  "/job-searching/standing-out": "ST",
  "/job-searching/offer-analysis": "OA",
  "/job-searching/salary-research": "SH",
  "/job-searching/reflections": "JR",
  "/job-searching/key-links": "SK",
  "/job-searching/helpful-tools": "HT",
  "/events/past-events": "EV",
  "/events/upcoming-events": "UE",
  "/events/find-events": "FE",
  "/career-advancement/onboarding-30-60-90": "OD",
  "/career-advancement/onboarding-checklist": "OC",
  "/career-advancement/promotions": "PR",
  "/career-advancement/internal-mobility": "IM",
  "/career-advancement/performance-reviews": "MV",
  "/career-advancement/job-expectations": "JE",
  "/career-advancement/annual-goals": "CG",
  "/career-advancement/stakeholder-updates": "SU",
  "/career-advancement/track-achievements": "TA",
  "/entrepreneurship/roadmap": "EM",
  "/entrepreneurship/customer-personas": "CS",
  "/entrepreneurship/market-research": "MR",
  "/entrepreneurship/define-offerings": "DO",
  "/entrepreneurship/financials": "FN",
  "/entrepreneurship/marketing": "MK",
  "/entrepreneurship/sales": "SL",
  "/entrepreneurship/product-development": "PD",
  "/entrepreneurship/team-management": "ET",
  "/entrepreneurship/legal": "EL",
  "/entrepreneurship/operations": "OP",
  "https://www.youtube.com/channel/UCzENh4CtxdGdnsABkLHeAAg": "WVM",
  "/other-videos": "OVD",
  "https://drive.google.com/file/d/1r0_pYv6MpTNXKBxlhK0aU9TjadZzMyOO/view": "WB",
  "/other-books": "OTB",
  "https://www.iamwoken.com/resources": "WKB",
  "/other-blogs": "OBL",
  "https://www.iamwoken.com/resources": "WW",
  "/podcasts": "PDC",
  "/templates": "TMP",
  "https://docs.google.com/document/d/12C7ZbxUvSIIRQuxkPt304th27gfPdHgxvDMiiZ8LCQU/edit?usp=sharing": "FAQ",
  "/whiteboard": "WHB",
  "/key-links": "KLJ",
  "/settings": "SE",
  "/security": "SC",
  "/my-plan": "MP",
  "/billing": "BL",
  "/integrations": "IN",
  "#": "SF",
  "/profile/privacy-policy": "PP",
  "#": "LG",
}